import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { InputObject } from "../controls/default";

// Mirrors backend EngagementEventType — platform-level engagement signals.
export enum EngagementEventType {
  Login = "Login",
  QuestionnaireCompleted = "QuestionnaireCompleted",
}

export interface PointsRulesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly eventType: InputObject;
  readonly points?: number;
  readonly isActive?: boolean;
  readonly description?: string;
}

export const pointsRulesViewColumns: DataColumn[] = [
  {
    title: "Event Type",
    key: "eventType",
    width: 220,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  { title: "Points", key: "points", width: 100, sort: true },
  {
    title: "Active",
    key: "isActive",
    width: 100,
    sort: true,
    transform: (v: boolean) => (v ? "Yes" : "No"),
  },
  { title: "Description", key: "description", width: 360, sort: true },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const pointsRulesQueryMappings: QueryFieldMapping[] = [
  { formField: "eventType", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "description", operation: QueryOperation.StartsWith },
];

export const mapPointsRulesViewQuery = (values: PointsRulesForm): SearchQuery =>
  buildSearchQuery(values, pointsRulesQueryMappings);
